import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-icones-acoes" }
const _hoisted_5 = { class: "ss-icones-acoes" }
const _hoisted_6 = { class: "ss-principais-acoes" }
const _hoisted_7 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Novo", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "ss-tela-conteudo",
  style: {"overflow":"hidden"}
}
const _hoisted_11 = {
  key: 0,
  class: "ss-card ss-card-space"
}
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1)
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_15 = {
  class: "ss-card ss-card-space ss-tela-conteudo-completo ss-alinhar-texto-esquerda",
  style: {"overflow":"hidden"}
}
const _hoisted_16 = {
  key: 0,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 3,
  class: "acoes-item-mobile"
}
const _hoisted_22 = { class: "acoes-item" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 4,
  class: "acoes-item"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["title", "onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 5 }
const _hoisted_34 = { key: 6 }
const _hoisted_35 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_preferencias_coluna = _resolveComponent("preferencias-coluna")!
  const _component_personalizacao_tela_modal = _resolveComponent("personalizacao-tela-modal")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_card = _resolveComponent("card")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.props.estrutura.identificadorRecurso,
          tituloRecurso: _ctx.props.estrutura.titulo,
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas
        }, {
          ExtrasTitulo: _withCtx(() => [
            (!_ctx.storeSistema.state.layoutMobile)
              ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.apresentarPersonalizacaoTela && _ctx.apresentarPersonalizacaoTela(...args)))
                            }, "Personalizar Tela")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.apresentarPersonalizarColuna && _ctx.apresentarPersonalizarColuna(...args)))
                            }, "Personalizar Colunas")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_4, [
                      _createVNode(_component_icone, { nome: "personalizacoes" })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.storeSistema.state.layoutMobile)
              ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 1 }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.salvarFiltrosBuscaAvancada && _ctx.salvarFiltrosBuscaAvancada(...args)))
                            }, "Salvar filtros")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.salvarOrdenacaoBuscaAvancada && _ctx.salvarOrdenacaoBuscaAvancada(...args)))
                            }, "Salvar ordenação")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.salvarPersonalizacaoColunas && _ctx.salvarPersonalizacaoColunas(...args)))
                            }, "Salvar personalizações")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.salvarTodasPreferencias && _ctx.salvarTodasPreferencias(...args)))
                            }, "Salvar tudo")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.redefinirPersonalizacaoColunas && _ctx.redefinirPersonalizacaoColunas(...args)))
                            }, "Redefinir personalizações")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_5, [
                      _createVNode(_component_icone, { nome: "filtro" })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.telaBase.permissaoDados.incluir)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Importar pelo Excel",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.abrirImportacaoExcel && _ctx.abrirImportacaoExcel(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "download" })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Imprimir",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                }, [
                  _createVNode(_component_icone, { nome: "imprimir" })
                ]),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Exportar Word",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                }, [
                  _createVNode(_component_icone, { nome: "word" })
                ]),
                _createElementVNode("button", {
                  class: "ant-btn ant-btn-secondary ss-btn-recursos",
                  title: "Exportar Excel",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                }, [
                  _createVNode(_component_icone, { nome: "excel" })
                ]),
                _renderSlot(_ctx.$slots, "BotoesAdicionais"),
                (_ctx.telaBase.permissaoDados.incluir)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "ant-btn ant-btn-primary ss-btn-tela",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.novoRegistro && _ctx.novoRegistro(...args)))
                    }, _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 3
        }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.telaBase.apresentarEmpresas)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_select, {
                      value: _ctx.telaBase.empresasSelecionadas,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event)),
                      mode: "multiple",
                      style: {"width":"100%"},
                      optionFilterProp: "label",
                      onChange: _ctx.atualizarSelecaoEmpresas,
                      allowClear: true,
                      options: _ctx.telaBase.empresasDisponiveis
                    }, null, 8, ["value", "onChange", "options"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_preferencias_coluna, {
            colunas: _ctx.tela.colunas,
            "onUpdate:colunas": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tela.colunas) = $event)),
            visivel: _ctx.tela.exibirPersonalizarColunas,
            "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tela.exibirPersonalizarColunas) = $event))
          }, null, 8, ["colunas", "visivel"]),
          _createVNode(_component_personalizacao_tela_modal, {
            visivel: _ctx.tela.exibirPersonalizacaoTela,
            "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.tela.exibirPersonalizacaoTela) = $event)),
            recurso: _ctx.props.estrutura.identificadorRecurso
          }, null, 8, ["visivel", "recurso"]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_busca_geral, {
              empresas: _ctx.telaBase.empresasSelecionadas,
              ordenacao: _ctx.tela.ordenacaoCampos,
              "onUpdate:ordenacao": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tela.ordenacaoCampos) = $event)),
              buscaRapida: _ctx.tela.buscaRapida,
              "onUpdate:buscaRapida": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.tela.buscaRapida) = $event)),
              buscaAvancada: _ctx.tela.buscaAvancada,
              "onUpdate:buscaAvancada": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tela.buscaAvancada) = $event)),
              onBuscarDados: _ctx.aplicarFiltros
            }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"]),
            _createVNode(_component_card, { titulo: " " }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  columns: _ctx.storeSistema.state.layoutMobile ? _ctx.gradeBase.colunasMobile : _ctx.tela.colunas.filter(item => item.visible),
                  "data-source": _ctx.tela.dados,
                  rowKey: "codigo",
                  pagination: false,
                  loading: _ctx.telaBase.carregando,
                  scroll: { y: _ctx.tela.windowHeight },
                  "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.onSelectChange },
                  size: "small"
                }, {
                  bodyCell: _withCtx(({ column, record, text }) => [
                    ((column.key === 'Cadastro'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tela.colunas.filter(ColunaGrade => ColunaGrade.visible), (coluna) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: coluna.key
                            }, [
                              (coluna.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                    _createElementVNode("b", null, _toDisplayString(coluna.title) + ":", 1),
                                    _createTextVNode(),
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.editarRegistro(record.codigo))
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(record[_ctx.obtemDataIndex(coluna)]), 1)
                                    ], 8, _hoisted_18)
                                  ]))
                                : (coluna.customRenderRow === _ctx.ECustomRenderRow.TagAtivo)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                      _createElementVNode("b", null, _toDisplayString(coluna.title) + ":", 1),
                                      _createTextVNode(),
                                      _createVNode(_component_a_tag, {
                                        class: _normalizeClass(record.ativo === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(record.ativo === true ? 'Ativo' : 'Inativo'), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]))
                                  : (coluna.customRenderRow === _ctx.ECustomRenderRow.TagSimNao)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                        _createElementVNode("b", null, _toDisplayString(coluna.title) + ":", 1),
                                        _createTextVNode(),
                                        _createVNode(_component_a_tag, {
                                          class: _normalizeClass(text === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(text === true ? 'Sim' : 'Não'), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["class"])
                                      ]))
                                    : ((coluna.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes && _ctx.gradeBase.visibilidadeColunaAcoes))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                          _createElementVNode("b", null, _toDisplayString(coluna.title), 1),
                                          _createElementVNode("div", _hoisted_22, [
                                            (_ctx.telaBase.permissaoDados.imprimir)
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 0,
                                                  title: "Imprimir",
                                                  class: "imprimir",
                                                  onClick: ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF, record.codigo))
                                                }, [
                                                  _createVNode(_component_icone, { nome: "imprimir" })
                                                ], 8, _hoisted_23))
                                              : _createCommentVNode("", true),
                                            ((_ctx.telaBase.permissaoDados.excluir))
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 1,
                                                  title: "Excluir",
                                                  onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                                                  class: "excluir"
                                                }, [
                                                  _createVNode(_component_icone, { nome: "excluir" })
                                                ], 8, _hoisted_24))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                          _createElementVNode("b", null, _toDisplayString(coluna.title) + ":", 1),
                                          _createTextVNode(" " + _toDisplayString(record[_ctx.obtemDataIndex(coluna)]), 1)
                                        ], 64))
                            ]))
                          }), 128))
                        ]))
                      : (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.editarRegistro(record.codigo))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(text), 1)
                          ], 8, _hoisted_25))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.TagAtivo)
                          ? (_openBlock(), _createBlock(_component_a_tag, {
                              key: 2,
                              class: _normalizeClass(record.ativo === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(record.ativo === true ? 'Ativo' : 'Inativo'), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          : (column.customRenderRow === _ctx.ECustomRenderRow.TagSimNao)
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 3,
                                class: _normalizeClass(text === false ? 'ss-tag-vermelho' : 'ss-tag-verde')
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(text === true ? 'Sim' : 'Não'), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  (_ctx.props.estrutura.apresentarAcaoVisualizarGrade)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        title: "Visualizar",
                                        class: "visualizar",
                                        onClick: ($event: any) => (_ctx.editarRegistro(record.codigo))
                                      }, [
                                        _createVNode(_component_icone, { nome: "visualizar" })
                                      ], 8, _hoisted_27))
                                    : _createCommentVNode("", true),
                                  (_ctx.props.estrutura.apresentarAcaoDuplicarGrade && _ctx.telaBase.permissaoDados.incluir)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        title: "Duplicar",
                                        class: "visualizar",
                                        onClick: ($event: any) => (_ctx.duplicarRegistro(record.codigo))
                                      }, [
                                        _createVNode(_component_icone, { nome: "duplicar" })
                                      ], 8, _hoisted_28))
                                    : _createCommentVNode("", true),
                                  (_ctx.props.estrutura.apresentarAcaoCriarFilhoGrade && _ctx.telaBase.permissaoDados.incluir)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        title: _ctx.props.estrutura.textoAcaoCriarFilhoGrade,
                                        class: "visualizar",
                                        onClick: ($event: any) => (_ctx.criarRegistroFilho(record.codigo))
                                      }, [
                                        _createVNode(_component_icone, { nome: "mais" })
                                      ], 8, _hoisted_29))
                                    : _createCommentVNode("", true),
                                  (_ctx.props.estrutura.apresentarAcaoImprimirGrade && _ctx.telaBase.permissaoDados.imprimir)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 3,
                                        title: "Imprimir",
                                        class: "imprimir",
                                        onClick: ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF, record.codigo))
                                      }, [
                                        _createVNode(_component_icone, { nome: "imprimir" })
                                      ], 8, _hoisted_30))
                                    : _createCommentVNode("", true),
                                  (_ctx.props.estrutura.apresentarAcaoImprimirEtiqueta && _ctx.telaBase.permissaoDados.imprimir)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 4,
                                        title: "Imprimir Etiqueta",
                                        class: "imprimir",
                                        onClick: ($event: any) => (_ctx.imprimirEtiqueta(record.codigo))
                                      }, [
                                        _createVNode(_component_icone, { nome: "tag" })
                                      ], 8, _hoisted_31))
                                    : _createCommentVNode("", true),
                                  (_ctx.props.estrutura.apresentarAcaoExcluirGrade && _ctx.telaBase.permissaoDados.excluir)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 5,
                                        title: "Excluir",
                                        onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                                        class: "excluir"
                                      }, [
                                        _createVNode(_component_icone, { nome: "excluir" })
                                      ], 8, _hoisted_32))
                                    : _createCommentVNode("", true)
                                ]))
                              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararTelefoneCelular)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(text)), 1))
                                  : _createCommentVNode("", true)
                  ]),
                  emptyText: _withCtx(() => [
                    _createVNode(_component_mensagem_sem_dados, {
                      resultadoPesquisa: !_ctx.telaBase.carregando,
                      mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado com estes filtros!'
                    }, null, 8, ["resultadoPesquisa", "mensagem"])
                  ]),
                  _: 1
                }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_a_pagination, {
                      class: "ss-paginacao-completa",
                      current: _ctx.tela.paginacao.current,
                      "onUpdate:current": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.tela.paginacao.current) = $event)),
                      size: "small",
                      total: _ctx.tela.paginacaoApi.totalRegistros,
                      "show-total": _ctx.apresentarTotalPaginacao,
                      "page-size": _ctx.tela.paginacao.pageSize,
                      pageSizeOptions: _ctx.tela.paginacao.pageSizeOptions,
                      onShowSizeChange: _ctx.onShowSizeChange,
                      showSizeChanger: _ctx.tela.paginacao.showSizeChanger,
                      onChange: _ctx.onPageChange,
                      locale: { items_per_page: ' por página' }
                    }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "showSizeChanger", "onChange"])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "CrudModal"),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.tela.arquivosPdf
    }, null, 8, ["arquivos"]),
    _renderSlot(_ctx.$slots, "ModalImportacaoExcel")
  ]))
}